import { Component, EventEmitter, Injector, Input, OnChanges, Output, ChangeDetectionStrategy } from '@angular/core';
import { AbstractComponent, AttendanceMessageHit, HighlightSegment, buildExcerpt, highlightSegments } from 'lib-trend-core';
import { MessageHitsState } from '../../state/app.state';

interface MessageHitRow {
  hit: AttendanceMessageHit;
  segments: HighlightSegment[];
  icon: string | null;
}

const MEDIA_ICONS: Record<string, string> = {
  image: 'ri-image-line',
  video: 'ri-video-line',
  audio: 'ri-mic-line',
  document: 'ri-file-text-line',
};

/** "Mensagens" section of the inbox search (SPEC-2026-09-attendance-message-search). */
@Component({
    selector: 'attendance-message-hits-component',
    templateUrl: 'attendance-message-hits.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AttendanceMessageHitsComponent extends AbstractComponent implements OnChanges {

  @Input() state: MessageHitsState;
  @Output() select = new EventEmitter<AttendanceMessageHit>();
  @Output() loadMore = new EventEmitter<void>();
  @Output() retry = new EventEmitter<void>();

  rows: MessageHitRow[] = [];

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnChanges(): void {
    const term = this.state?.search ?? '';
    this.rows = (this.state?.hits ?? []).map((hit) => ({
      hit,
      segments: highlightSegments(buildExcerpt(hit.text, term), term),
      icon: MEDIA_ICONS[hit.messageType] ?? null,
    }));
  }
}
